export enum AadEvents {
  ON = 'EAD_on',
  OFF = 'EAD_off',
  SKIP = 'EAD_skip',
  PLAY = 'EAD_play',
  REPLAY = 'EAD_replay',
  SCROLL = 'EAD_scroll',
  EAD_pause = 'EAD_pause',
  EAD_resume = 'EAD_resume'
}

export enum AadEventTriggers {
  BUTTON = 'button',
  SHORTCUT = 'keyboard_shortcut'
}
